import React, { useState } from "react";
import ParcelCard from "domains/Request/component/ParcelCard";
import { BadgeIcon, LocalisationPinIcon, PriceIcon, QuantityIcon } from "icons";
import { Button } from "ui/Button";
import useText from "constants/text";
import clsx from "clsx";
import { Advantage, Program } from "generated/graphql";
import { formatAmount } from "utils";
import { USE_ADVANTAGE } from "graphql/Fidelity/mutations";
import { useMutation } from "@apollo/client";
import { useAlertDispatch } from "contexts/AlertContext";
import { isSuccess } from "utils/https";
import { CircularProgress } from "@material-ui/core";
import { StyledAdvantagePrice, StyledAdvantageTitle, useAdvantageDetailsStyles } from "../style";
import Location from "../components/Location";
import { formatAddress } from "../utils";
import UseProgramDialog from "../components/modals/UseProgramDialog";

interface AdvantageDetailsProps {
  advantage: Advantage;
  onCancel: () => void;
  clientiId: string;
  program?: Program;
}
function AdvantageDetails({ advantage, onCancel, clientiId, program }: AdvantageDetailsProps) {
  const { text } = useText();
  const styles = useAdvantageDetailsStyles();
  const [open, setOpen] = useState<boolean>(false);
  const [locationShow, setLocationShow] = useState<boolean>(false);

  const onClose = () => {
    onCancel();
    setOpen(false);
  };

  const onOpen = () => {
    setOpen(true);
  };
  const toggleShowLocation = () => {
    setLocationShow(!locationShow);
  };

  return (
    <div className={clsx(styles.container, "animate-details")}>
      <div className={styles.content}>
        <div className={styles.header}>
          <div className={styles.badgeImage}>
            <BadgeIcon />
          </div>
          <StyledAdvantageTitle fontSize="36px">{advantage?.service?.label}</StyledAdvantageTitle>
          <StyledAdvantagePrice>{`${advantage?.maxAmount}%`}</StyledAdvantagePrice>
        </div>

        <p className={styles.description}>{advantage?.service?.description}</p>

        <div className={!locationShow ? styles.locationContainer : styles.locationContainerActive}>
          <div className={styles.location} onClick={toggleShowLocation}>
            <div className={styles.locationIconContainer}>
              <LocalisationPinIcon color="#399ebf" />
            </div>
            <span className={styles.locationText}>{text.all.location}</span>
          </div>
          {locationShow && (
            <div className={styles.locationPoint}>
              <Location address={advantage?.address} />
            </div>
          )}
        </div>
        <div className={styles.pricing}>
          <ParcelCard
            icon={<QuantityIcon width={20} height={20} color="#fff" />}
            title={text.all.quantity}
            value={advantage?.remainQuantity}
          />
          <ParcelCard
            icon={<PriceIcon color="#fff" width={20} height={20} />}
            title={text.all.max_amount}
            value={`${advantage?.maxAmount}%`}
          />
        </div>
      </div>

      <div className={styles.footerButtons}>
        <Button
          className={styles.useButton}
          style={{ width: "100%" }}
          onClick={onOpen}
          disabled={advantage?.remainQuantity <= 0}
        >
          {text.all.use}
        </Button>
      </div>
      <UseProgramDialog
        endDate={program?.endDate}
        clientId={clientiId}
        advantage={advantage}
        open={open}
        onClose={onClose}
      />
    </div>
  );
}

export default AdvantageDetails;
